import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { H4 } from 'components/typography/Headers';

export const Header = styled(H4)`
  color: ${theme.color.red};
`;
